import MentorRequestContainer from '../mentor-request-container';
import { useMentorRequestContext } from '../mentor-request-context';

const PendingRequestMenteeView = () => {
  const { requests } = useMentorRequestContext();
  return (
    <>
      <MentorRequestContainer.Header />
      <MentorRequestContainer.Description />
      {requests.map((request) => (
        <MentorRequestContainer.Request
          key={`mentor-request-${request.id}`}
          request={request}
        />
      ))}
      <MentorRequestContainer.WithdrawRequest />
    </>
  );
};

export default PendingRequestMenteeView;
